import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan } from '../../misc';

const  EventSearchAltSearchResultsHint = ({eventHasSearchByFace}) => {
  return (
    <div className='event-search-alt-results-hint'>
      <FormattedMessageWrappedInSpan
        id="eventSearchAltSearchResultsHint.addToPackageTitle"
        defaultMessage="Tag photos which show you to add them to your package"
        className="typography bold-text mt-10 mb-10"
      />
      <p  className="mb-30">
        {eventHasSearchByFace && (
          <FormattedMessageWrappedInSpan
            id="eventSearchAltSearchResultsHint.searchByFace.addToPackageSubtitle"
            defaultMessage="Click on a photo and leave your email address."
          />
        )}
        {!eventHasSearchByFace && (
          <FormattedMessageWrappedInSpan
            id="eventSearchAltSearchResultsHint.bibSearch.addToPackageSubtitle"
            defaultMessage="Click on a photo and leave your bib number and email address."
           
          />
        )}
      </p>
    </div>
  );
}


EventSearchAltSearchResultsHint.propTypes = {
  eventHasSearchByFace: PropTypes.bool,
};

export default EventSearchAltSearchResultsHint;
